var React = require('react');

function CloseModalInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"11.1462","y1":"0.439491","x2":"1.13669","y2":"10.449","stroke":"currentCOlor","key":0}),React.createElement("line",{"x1":"11.4051","y1":"10.4493","x2":"1.39559","y2":"0.439745","stroke":"currentCOlor","key":1})]);
}

CloseModalInline.defaultProps = {"width":"12","height":"11","viewBox":"0 0 12 11","fill":"none"};

module.exports = CloseModalInline;

CloseModalInline.default = CloseModalInline;
